const recurringInput = {
  repeatEvery: 'Repetir a Cada',
  repeatOn: 'Repetir em',
  ends: 'Termina em',
  endsOn: 'Finaliza em',

  form: {
    month: 'Mês',
    day: 'Dia',
    week: 'Semana',
    year: 'Ano',
    occurrences: 'Ocorrências',
    after: 'Depois',
    never: 'Nunca',
    on: 'Em',
  },
};

export default recurringInput;
